import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { configuration } from '@janus.team/janus-particles';
import { CustomerApp } from './customer.js';
import { RackerApp } from './racker.js';
import { componentMaturity } from 'config/index.js';
import { QueryClient, QueryClientProvider } from 'react-query';
 
export const queryClient = () => (new QueryClient({
  defaultOptions: {
    queries: {
      cacheTime: 3600 * 24 * 1000,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchInterval: false,
      staleTime: Infinity
    }
  }
}));

export const App = () => (
  <React.Fragment>
    <QueryClientProvider {...{ client: queryClient() }}>
      <configuration.ConfigurationProvider componentMaturity={componentMaturity()}>
        <Switch>
          <Route path="/racker*">
            <RackerApp />
          </Route>
          <Route path="/*">
            <CustomerApp />
          </Route>
        </Switch>
      </configuration.ConfigurationProvider>
    </QueryClientProvider>
  </React.Fragment>
);

export const AppWithRouter = () => (
  <BrowserRouter basename={process.env.PUBLIC_URL}>
    <App />
  </BrowserRouter>
);

export default AppWithRouter;

